import React,{useEffect, useState} from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { useLocation, useNavigate } from 'react-router-dom';
import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
import { IconButton } from '@mui/material'
import {BsArrowRepeat} from 'react-icons/bs';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { Modal } from 'antd';
import toast from 'react-hot-toast';
import { DatePicker } from 'antd';
import { DeleteCaseService, GetCaseService,UploadCaseFile,UploadCaseDocsForCaseService } from '../../services/CaseService';
import CaseMenu from './BillsMenu';
import { TbUpload } from "react-icons/tb";
import { TextInput } from '../../components/input';
import Uploader from '../../components/Uploader';
import BillsMenu from './BillsMenu';
import { DeleteBillsService, GetAllBillsService } from '../../services/BillService';
import { useSelector } from 'react-redux';


function BillsList() {

  const roles = useSelector(state=>state.Auth.roles)

  const navigator = useNavigate()
  const [page,setpage] = useState(1)
  const [modal,setmodal] = useState(false)
  const [uploadmodal,setuploadmodal] = useState(false)
  const [search,setsearch] = useState({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
  const [data,setdata] = useState({})  
  const [selecteddata,setselecteddata] = useState({})  

  const [uploadData,setuploadData] = useState({file:'',name:''})
  const [error,seterror] = useState({file:'',name:''})

  const {pathname} = useLocation()
  const path = pathname?.split('/')[pathname?.split('/')?.length - 1]
  
  const [step,setstep] = useState(1)

  const steps = [
    'Pending',
    'Completed',
  ]

  useEffect(()=>{
    getData()
  },[page,pathname,step])

  async function getData(){
    const response = await GetAllBillsService(page,search?.text,search?.from_date1,search?.to_date1,step)
    setdata(response?.data)
  }

  const navigate = useNavigate() 

  async function applyfilter(){
    const response = await GetAllBillsService(1,search?.text,search?.from_date1,search?.to_date1,step)
    setdata(response?.data)
  }

  async function UploadFile(e,name){
    const response = await UploadCaseFile({file:e})
    setuploadData({...uploadData,[name]:response?.data?.data,name:response?.data?.data})
  }

  async function resetfunc(){
    setpage(1)
    setsearch({text:'',from_date:'',from_date1:'',to_date:'',to_date1:''})
    const response = await GetAllBillsService(1,'','','',step)
    setdata(response?.data)
  }  

  async function deleteData(){
    const response = await DeleteBillsService(selecteddata?._id)
    if(response?.status === 200){
      getData()
      setmodal(false)
      toast.success("Deleted Successfully!")
    }
  }

  async function handlechange(e){
    setuploadData({...uploadData,[e.target.name]:e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function uploadDocsForCase(){
    const sendData = {...uploadData}
    sendData['case'] = selecteddata?._id
    const response = await UploadCaseDocsForCaseService(sendData)
    if(response?.status === 200){
      toast.success("File Uploaded Successfully!")
      setuploadmodal(false)
      setuploadData({file:'',name:''})
    }
  }




  let rupee = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  });

  console.log("data",data)


  return (
    <div className='flex pt-5 md:pt-0 flex-col md:flex-row'>
        <Modal className='absolute top-0  left-[40%]' width={300} footer={false} closable={false} open={modal}>
          <div>
            <h6 className='text-[13px] font-[700]'>Delete Data</h6>
            <h6 className='text-[12px] bg-slate-100 p-[4px]'>Are you sure want to delete the selected Data</h6>
             
            <div className='my-1'>
               <h6 className='text-[11px]'>Bill Info : <span className='font-[700]'>{selecteddata?.bill_info}</span></h6>
               <h6 className='text-[11px]'>Bill Id : <span className='font-[700]'>{selecteddata?.bill_id}</span></h6>
            </div> 

            <h6 className='font-[700] text-[10px]'>Client Info</h6>
            <div className='bg-slate-100 p-1'>

              {selecteddata?.type === 'opinion_file' && <>
              <h6 className='text-[11px]'>Client Name : <span className='font-[500]'>{selecteddata?.opinion_file?.client?.name}</span></h6>
              <h6 className='text-[11px]'>Work Info : <span className='font-[500]'>{selecteddata?.opinion_file?.work_details}</span></h6>
              </>}

              {selecteddata?.type === 'case' && <>
              <h6 className='text-[11px]'>Client Name : <span className='font-[500]'>{selecteddata?.case?.client?.name}</span></h6>
              <h6 className='text-[11px]'>Work Info : <span className='font-[500]'>{selecteddata?.case?.work_details}</span></h6>
              </>}
              <h6 className='text-[11px]'>Bill Type : <span className='font-[500] uppercase'>{selecteddata?.type?.replace('_',' ')}</span></h6>
            </div>

            <div className='flex items-center mt-2 border-t pt-2'>
               <ButtonOutlinedAutoWidth onClick={()=>setmodal(false)} btnName="Cancel" />
               <h6 className='w-[10px]'></h6>
               <ButtonFilledAutoWidth btnName="Save" onClick={deleteData} />
            </div>
          </div>

        </Modal>

      

        <BillsMenu />
        <div className='md:w-[85%] px-4 pt-2 md:pt-2'>
        <div className='flex flex-col md:flex-row border-b pb-2 border-slate-200 w-[100%] md:items-center justify-between'>


          <div className='flex items-center justify-between'>
          <h6 className='font-[600] text-[14px] '>{`Total Bills`}  ({data?.pagination?.total})</h6>

          <div className='block md:hidden items-center '>
            <div className='flex md:hidden items-center  text-[12px] mr-2'>

            <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
            <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

            <div>
            <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

            </div>
            </div>
          </div>
          </div>

          <div className='flex flex-col md:flex-row items-start md:items-center mt-2 md:mt-0'>
            <div className='hidden md:flex items-center  text-[12px] mr-2'>

            <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
            <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

            <div>
            <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

            </div>
            </div>

          <div className='flex'>
          <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.from_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,from_date:v,from_date1:v1})}} /> 

          <DatePicker size='small' style={{fontSize:'11px',minWidth:'90px'}} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2'  value={search?.to_date} onChange={(v,v1) => {console.log('v na',new Date(v).toLocaleDateString());setsearch({...search,to_date:v,to_date1:v1})}} /> 

          <input id="search_text" placeholder='Search ...' type='text' value={search?.text}  onChange={(e)=>setsearch({...search,text:e.target.value})} className='border text-sm py-[4px] focus:ring-0  focus:outline-0 text-[13px]  w-28 px-1 rounded-md border-slate-300' />
          </div>
          <div className="mt-2 md:mt-0 md:ml-2 flex">
          <ButtonOutlinedAutoWidth onClick={()=>{setpage(1);applyfilter()}}  btnName="Add Filter" />

          {/* <div className="ml-2">
          <ButtonFilledAutoWidth btnName="Add New" onClick={()=>navigate('create')}   />
          </div>  */}
          </div> 
          </div>
       </div>
       <div className='border-b flex items-center'>
       {steps?.map((s,i)=>(
        <h6 onClick={()=>{setstep(i+1);setpage(1)}} className={` ${step === i+1 ? 'bg-[#1b3f69] text-white' : ''} cursor-pointer px-2 p-1.5 text-[10px] font-[600]`}>{s}</h6>
       ))}
       </div>
       
       
        {data?.datas?.length === 0 &&
            <div className='grid place-items-center mt-20  items-center justify-center'>
            <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
            <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
            <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
          </div>
          }

          {data?.datas?.length > 0 &&
          <div className='max-h-[82vh] mt-4 border-t md:overflow-x-hidden w-[100%]  border-l border-r overflow-y-scroll'>
            <div className='sticky top-0 z-50 flex w-max md:w-[100%] bg-white py-[-5px] border-b border-slate-200 relative'>
                <h6  className='top-0 bg-white z-50 text-[12px] w-[70px] min-w-[70px] md:w-[5%]  px-2 py-1 font-[600] text-slate-600 border-r flex items-center justify-center'>SL NO</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[140px] min-w-[140px] md:w-[12%]  px-2 py-1 font-[600] text-slate-600 border-r'>Client Info</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[160px] min-w-[160px] md:w-[14%]  px-2 py-1 font-[600] text-slate-600 border-r'>Work Info</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[160px] min-w-[160px] md:w-[14%] px-2 py-1 font-[600] text-slate-600 border-r'>Amount With Gst</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[160px] min-w-[160px] md:w-[14%] px-2 py-1 font-[600] text-slate-600 border-r'>Amount Without Gst</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[200px] min-w-[200px] md:w-[20%] px-2 py-1 font-[600] text-slate-600 border-r'>Bill Info</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[160px] min-w-[160px] md:w-[12%] px-2 py-1 font-[600] text-slate-600 border-r'>Payment Received</h6>
                <h6 className='sticky top-0 z-50  text-[12px] w-[120px] min-w-[120px] md:w-[7%]  px-2 py-1 font-[600] text-slate-600'>Actions</h6>
            </div>
            {data?.datas?.map((d,i)=>(
            <div className='flex  w-max md:w-[100%] cursor-pointer bg-white py-[-5px] border-b border-slate-200 relative'>
                <h6 className='bg-white truncate z-50 text-[12px] w-[70px] min-w-[70px] md:w-[5%]  px-2 py-1 text-black border-r flex items-start justify-center'>{page == 1 ? i+1 : (data?.pagination?.limit * (page - 1)) + (i+1)}</h6>
                <h6 onClick={()=>d?.type == 'opinion_file' ? navigator(`/client/${d?.opinion_file?.client?.is_active ? 'active' : 'in_active'}/edit`,{state:d?.opinion_file?.client}) :  navigator(`/client/${d?.case?.client?.is_active ? 'active' : 'in_active'}/edit`,{state:d?.case?.client})} className='text-[11px] w-[140px] break-all min-w-[140px] md:w-[12%]  px-2 py-1 opacity-70  text-black border-r text-slate-900 hover:underline'>
                 {d?.type == 'opinion_file' ?
                 <>
                 {d?.opinion_file?.client?.name} / <span className='font-[700]'>{d?.opinion_file?.client?.mobile}</span>
                 </>
                 :
                 <>
                 {d?.case?.client?.name} / <span className='font-[700]'>{d?.case?.client?.mobile}</span>
                 </>}
                </h6>
                {console.log("d?.case",d?.case)}
                <h6 onClick={()=>d?.type == 'opinion_file' ?  navigate('/opinion_files/list/detail',{state:d?.opinion_file}) : navigate(`/case/${d?.case?.case_type?.name === "Civil Court" ? 'civil_court' : 'high_court'}/detail`,{state:d?.case})  } className='text-[11px]  w-[160px] break-all min-w-[160px] md:w-[14%]  px-2 py-1  opacity-70 text-black border-r'>
                {d?.type == 'opinion_file' ?
                 <>
                  Office File No : <span className='font-[700]'>{d?.opinion_file?.office_file_no}</span> <br></br> Work Info : {d?.opinion_file?.work_details}
                 </>
                  :
                  <>
                  Office File No : <span className='font-[700]'>{d?.case?.office_file_no}</span> <br></br> Case No : {d?.case?.case_no} <br></br> Work Info : {d?.case?.work_details}
                  </>}
                
                </h6>
                <h6 className='text-[11px] w-[160px] break-all min-w-[160px] md:w-[14%]  px-2 py-1 opacity-70  text-black border-r'>{rupee?.format(d?.amountWithGst)?.split('.')[0]}</h6>
                <h6 className='text-[11px] w-[160px] break-all min-w-[160px] md:w-[14%] px-2 py-1  opacity-70 text-black border-r'>{rupee?.format(d?.amountWithoutGst)?.split('.')[0]} </h6>
                <h6 className='text-[11px] w-[200px] break-all min-w-[200px] md:w-[20%] px-2 py-1  opacity-70 text-black border-r text-blue-500 hover:underline'> Bill Id : <span className='font-[700]'>{d?.bill_id}</span> / Bill Info : <span className='font-[700]'>{d?.bill_info}</span></h6>
                <h6 className='text-[11px] w-[160px] break-all min-w-[160px] md:w-[12%] px-2 py-1  opacity-70 text-black border-r'>{rupee?.format(d?.payment_recieved)?.split('.')[0]}</h6>
                <h6 className='text-[11px] flex w-[120px] break-all min-w-[120px] md:w-[7%]  px-2 py-1  opacity-70 text-black '>
                  {/* <TbUpload className='mr-2' onClick={()=>{setselecteddata(d);setuploadmodal(true)}} /> */}
                   {/* <AiOutlineEdit className='mr-2' onClick={()=>{navigate('edit',{state:d})}} /> */}
                  {['admin','Admin']?.filter((f)=>roles?.includes(f))?.length > 0 &&
                  <AiOutlineDelete onClick={()=>{setselecteddata(d);setmodal(true)}} />}
                </h6>
            </div>))}
          </div>}
       </div>
       
    </div>
  )
}

export default BillsList